export default __webpack_public_path__ + "static/media/call.3823ec5b.svg";